import { MatrixTotalsContextProvider } from '@app/components/products/ProductMatrix/context';
import React from 'react';

import { MatrixBody } from './MatrixBody';
import { MatrixHead } from './MatrixHead';

export const MatrixComponent = React.memo(() => {
  return (
    <table className="relative mb-3 border-separate border-spacing-0 border-none" data-matrix>
      <MatrixHead />
      <MatrixBody />
    </table>
  );
});

export const Matrix = React.memo(() => {
  return (
    <MatrixTotalsContextProvider>
      <MatrixComponent />
    </MatrixTotalsContextProvider>
  );
});
